import * as React from 'react'
import {connect} from 'react-redux'

import BuildLineLayout from '../../../../containers/BuildLineLayout'
import BuildsFetcher from '../../../../containers/BuildsFetcher'
import {STARRED_LOCATOR} from '../../../../types'
import Builds from '../../../common/Builds/Builds.container'
import BuildPager from '../../../common/Pager/BuildPager/BuildPager.container'
import {submitPager} from '../../../common/Pager/Pager.actions.base'
import type {Pager} from '../../../common/Pager/Pager.types'
import FavoriteBuildsSettingsMessage from '../FavoriteBuildsSettingsMessage/FavoriteBuildsSettingsMessage'

import styles from './FavoriteBuilds.css'

type ActionProps = {
  submitPager: (pager: Partial<Pager>) => unknown
}
const initialPager: Partial<Pager> = {
  lookupLimit: 10000,
  lookupDelta: 10000,
}
const actionCreators: ActionProps = {
  submitPager,
}

class FavoriteBuilds extends React.Component<ActionProps> {
  constructor(props: ActionProps) {
    super(props)
    props.submitPager(initialPager)
  }

  render() {
    return (
      <>
        <FavoriteBuildsSettingsMessage />
        <div className={styles.wrapper}>
          <BuildsFetcher
            updatePeriod={20000}
            withPager
            withQueued
            withRunning
            baseLocator={STARRED_LOCATOR}
          >
            <BuildLineLayout>
              <Builds alwaysShowLineBorders withPager withLoader />
              <BuildPager />
            </BuildLineLayout>
          </BuildsFetcher>
        </div>
      </>
    )
  }
}

export default connect(null, actionCreators)(FavoriteBuilds)
